import * as rules from './auth-rules';
import * as limit from './auth-limit';
import { IMenuItem } from './types';

// 企业的主菜单
const data: IMenuItem[] = [
  {
    title: '首页',
    icon: 'mdi-nav-dashboard',
    link: '/home',
    rule: rules.byAuth,
    auth: [null],
  },
  {
    title: '组织和用户',
    icon: 'mdi-nav-organize',
    rule: rules.byAuth,
    children: [
      {
        title: '用户管理',
        link: '/organization/user',
        rule: rules.byVip,
        auth: limit.DUser,
      },
      {
        title: '角色管理',
        link: '/organization/role',
        rule: rules.byVip,
        auth: limit.DUser,
      },
    ],
  },
  {
    title: '物料',
    icon: 'mdi-nav-material',
    rule: rules.byAuth,
    children: [
      {
        title: '物料检索',
        link: '/materials/search',
        rule: rules.byAuth,
        auth: [null],
      },
    ],
  },
  {
    title: '拼装家具',
    icon: 'mdi-nav-furniture',
    rule: rules.byModuleCode,
    moduleCode: ['FURNITURE'],
    children: [
      {
        title: '模块管理',
        link: '/furniture/block',
        rule: rules.byAuth,
        auth: limit.DBlock,
      },
      {
        title: '家具检索',
        link: '/furniture/search',
        rule: rules.byAuth,
        auth: [null],
      },
    ],
  },
  {
    title: '设计方案',
    icon: 'mdi-nav-design',
    rule: rules.byAuth,
    children: [
      {
        title: '专案管理',
        link: '/design/group',
        rule: rules.byAuth,
        auth: limit.DDpgGroup,
      },
      {
        title: '数字房型',
        link: '/design/digital-room',
        rule: rules.byAuth,
        auth: limit.DDpgGroup,
      },
      {
        title: '我的设计项目',
        link: '/design/acceptances',
        rule: rules.byAuth,
        auth: [null],
      },
    ],
  },
  {
    title: '设计服务',
    icon: 'mdi-nav-design',
    rule: rules.byDesignCenter,
    children: [
      {
        title: '接受设计项目',
        link: '/design/appointment',
        rule: rules.byAuth,
        auth: [null],
      },
      {
        title: '设计项目管理',
        link: '/design/inspections',
        rule: rules.byAuth,
        auth: [null],
      },
    ],
  },
  {
    title: '设计项目',
    icon: 'mdi-nav-design',
    rule: rules.byAuth,
    children: [
      {
        title: '我的设计项目',
        link: '/customer/project',
        rule: rules.byAuth,
        auth: [null],
      },
    ],
  },
  {
    title: '品牌数字门店',
    icon: 'mdi-store',
    rule: rules.byModuleCode,
    moduleCode: ['BRANDED_DIGITAL_STORES'],
    children: [
      {
        title: '门店管理',
        link: '/store/shop',
        rule: rules.byAuth,
        auth: limit.DBrandStore,
      },
      {
        title: '内容管理',
        link: '/store/resource',
        rule: rules.byAuth,
        auth: limit.DBrandStoreRes,
      },
    ],
  },
  {
    title: '数字资产',
    icon: 'mdi-nav-message',
    rule: rules.byModuleCode,
    moduleCode: ['DIGITAL_ASSET'],
    children: [
      {
        title: '类目管理',
        link: '/digital-asset/def',
        rule: rules.byVip,
        auth: limit.DAssetDef,
      },
      {
        title: '资产管理',
        link: '/digital-asset/product',
        rule: rules.byVip,
        auth: limit.DAssetProduct,
      },
      {
        title: '资产检索',
        link: '/digital-asset/search',
        rule: rules.byVip,
        auth: limit.DAssetRetrieve,
      },
    ],
  },
];

export default data;
